<template>
	<div class="link-all">
		<el-button type="primary" size="small" class="el-icon-plus fr" @click="dialogVisible = true">{{ addbtnLabel}}</el-button>
		<ul>
			<li class="clearfix mb-sm" v-for="(i,index) in linkInfo" :key="i.id">
				<span class="fl">{{index+1}}</span>
				<div class="desc fl">
					<h1>{{i.topic}}</h1>
					<h2>
						<i :class="mapLinkIcon(i.nodeType)"></i>
						{{i.nodeTypeDesc}}
					</h2>
				</div>
				<div class="do fr">
					<!-- <el-button type="text">查看</el-button> -->
					<el-button type="text" class="edit-but" @click="tabChange(i)">编辑</el-button>
					<el-button type="text" class="del-but" @click="delLink(i.nodeCode)">删除</el-button>
				</div>
			</li>
		</ul>
		<el-dialog :visible.sync="dialogVisible" top="12%" width="700px" class="add-dialog">
			<div class="add-content">
				<h2>添加文档</h2>
				<span v-for="i in nodeList.filter(i=>i.classify==='content')" :key="i.nodeType" class="clrarfix" @click="tabChange(i)">
					<i :class="mapLinkIcon(i.nodeType)"></i>
					<em>{{i.nodeDesc}}</em>
					<i class="fr el-icon-plus"></i>
				</span>
				<h2>添加互动</h2>
				<span v-for="i in nodeList.filter(i=>i.classify==='interact')" :key="i.nodeType" class="clrarfix" @click="tabChange(i)">
					<i :class="mapLinkIcon(i.nodeType)"></i>
					<em>{{i.nodeDesc}}</em>
					<i class="fr el-icon-plus"></i>
				</span>
			</div>
		</el-dialog>
		<!-- 删除的对话框 -->
		<popup-del :delVisible="delVisible" @close="closePopupDel"></popup-del>
	</div>
</template>
<script>
import PopupDel from "@/components/PopupDel.vue";
import { mapLinkIcon } from "@/utils/index.js";
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState } from "vuex";
export default {
	components: {
		PopupDel
	},
	props: {
		moduleType: "" //eduResearch 教研活动 	train 培训  topicResearch 项目课题研究
	},
	...mapState(["userInfo", "schoolList", "resOptions"]),
	data() {
		return {
			addbtnLabel: "",
			dialogVisible: false,
			delVisible: false,
			curNodeCode: "",
			nodeList: [],
			linkInfo: []
		};
	},
	created() {
		if (this.moduleType == "eduResearch") {
			this.addbtnLabel = "活动环节";
		} else if (this.moduleType == "train") {
			this.addbtnLabel = "培训环节";
		} else if (this.moduleType == "topicResearch") {
			this.addbtnLabel = "研究环节";
		}
		this.init();
	},
	methods: {
		mapLinkIcon,
		async init() {
			if (this.moduleType == "eduResearch") {
				this.nodeList = await getData("/research/getSysNodeConfigList");
				this.linkInfo = await getData("/research/getActiveNodeTopicList", {
					actCode: sessionStorage.getItem("actCode"),
					isSub: 0 //是否是子活动节点，0：否，1：是     只有项目课题研究是1
				});
			} else if (this.moduleType == "train") {
				this.nodeList = await getData("/training/getSysNodeConfigList");
				this.linkInfo = await getData("/training/getActiveNodeTopicList", {
					actCode: sessionStorage.getItem("actCode"),
					isSub: 0 //是否是子活动节点，0：否，1：是     只有项目课题研究是1
				});
			} else if (this.moduleType == "topicResearch") {
				// this.$router.push({
				// 	name: "detailTopic"
				// });
			}
		},

		tabChange(info) {
			this.dialogVisible = false;
			this.$emit("changTab", "linkAdd", info);
		},
		delLink(code) {
			this.delVisible = true;
			this.curNodeCode = code;
		},
		// 删除弹框 关闭
		async closePopupDel(status) {
			try {
				if (status) {
					await postData("/node/deleteNodeTopic", {
						nodeCode: this.curNodeCode
					});
					this.$message({
						message: "删除成功",
						type: "success",
						duration: 2000,
						offset: 150
					});
					this.delVisible = false;
					this.init();
				} else {
					this.delVisible = false;
				}
			} catch (err) {
				console.log("err", err);
			}
		}
	}
};
</script>

<style lang="less" scoped>
.link-all {
	padding: 20px 30px;
	ul {
		margin-top: 50px;
		padding-left: 0px;
		padding-bottom: 40px;
		li {
			border-radius: 8px;
			padding: 13px;
			cursor: pointer;
			border: 1px solid #dfd6d6;
			span {
				margin-top: 5px;
				border: 2px solid @color;
				color: @color;
				height: 30px;
				width: 30px;
				font-size: 20px;
				border-radius: 50%;
				text-align: center;
				line-height: 25px;
			}
			.desc {
				h1 {
					font-size: 15px;
					padding-left: 10px;
				}
				h2 {
					margin-top: 5px;
					font-size: 13px;
					padding-left: 10px;
					color: @hui;

					i {
						color: @color;
						font-size: 15px;
					}
				}
			}
			.edit-but {
				margin-left: 100px;
				margin-right: 80px;
			}
			.del-but {
				margin-right: 50px;
				color: @hong;
			}
		}
	}
	/deep/.el-dialog {
		border-radius: 20px;
		.add-content {
			padding: 0px 20px;
			h2 {
				font-size: 17px;
				font-weight: 700;
				margin-bottom: 25px;
			}
			span {
				cursor: pointer;
				vertical-align: middle;
				display: inline-block;
				width: 170px;
				color: @color;
				border-radius: 5px;
				background: #eee;
				padding: 12px 17px;
				font-size: 16px;
				margin-right: 35px;
				margin-bottom: 35px;
				em {
					color: rgb(59, 58, 58);
					margin-left: 15px;
				}
				i {
					vertical-align: middle;
					font-weight: 700;
					font-size: 20px;
				}
				i:nth-of-type(2) {
					font-size: 21px;
				}
			}
		}
	}
}
</style>